module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [(_vm.item.path !== 'merge') ? _c('router-link', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "to": _vm.item.path
    }
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]) : _vm._e(), (_vm.item.path === 'merge') ? _c('router-link', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "to": _vm.item.path
    }
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-gear fa-stack-1x fa-inverse"
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e4641726!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/CreateEntityButton.vue
// module id = 2738
// module chunks = 1